import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const AnalyzeIndicator = () => {
	const { t } = useTranslation();
	const [dots, setDots] = useState(".");

	useEffect(() => {
		const interval = setInterval(() => {
			setDots((prev) => (prev === "..." ? "." : prev + "."));
		}, 500);
		return () => clearInterval(interval); // Cleanup on unmount
	}, []);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: "20px",
				padding: 4,
			}}
		>
			<CircularProgress />
			<Typography
				component="p"
				variant="h4"
				sx={{ display: "flex", alignItems: "center", marginLeft: "20px" }}
			>
				{t("offers_analysis_and_creation_in_progress")}
				<span
					style={{
						display: "inline-block",
						width: "1.5em",
						textAlign: "left",
					}}
				>
					{dots}
				</span>
			</Typography>
		</Box>
	);
};
